import React, { useEffect, useRef, useState } from "react";
import { toast } from "react-toastify";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";



import useApiRequest from "../../../../Hooks/apiReq";
import TitleSection from "../../../../Shared/TitleSection/TitleSection";

import Loader from "../../../../CommonComponets/Loader";

import { convertToINRFormat } from "../../../../Utils/INRConvert";
import moment from "moment";
import BackButton from "../../../../Shared/BackButton";
const MyPayoutDetailOrg = () => {
    const [preFilter, setPreFilter] = useState({});
    // const { id } = useParams();
    const { state } = useLocation()
    const id = state?.payoutNo || ""
    const { error, loading, recallRequest, response, sendApiRequest, status } =
        useApiRequest();
    const navigate = useNavigate();
    const [myAllPayouts, setPayouts] = useState([]);

    const getPayoutDetails = (no) => {
        if (loading) return;
        const getLoaggedInUser = JSON.parse(sessionStorage.getItem("loggedInUser"));
        if (getLoaggedInUser) {
            var userData = {
                AutoId: getLoaggedInUser.AutoID,
                PayoutNo: no,
                LoginToken: getLoaggedInUser.LoginToken,
                DeviceType: "Web",
                AppVersion: JSON.parse(sessionStorage.getItem("loggedInUser"))?.AppVersion
            }
            sendApiRequest("POST", "/GetAssociatePayoutDetail", userData, "", true);
        }
    }
    useEffect(() => {
        getPayoutDetails(id);
    }, [])
    const handleClick = () => {
        navigate(state?.backLink, { replace: true })
    }
    return (
        <>
            <div class="content">
                <div class="container-fluid ">
                    <div class="row g-2 mx-1">
                        <div class="col-12">
                            <div className=" d-flex justify-content-between">
                                <TitleSection text="My Payout detail" />
                                <BackButton onClick={handleClick} />
                            </div>
                        </div>
                    </div>
                    {<PayoutSummaryCards response={response} />}
                    {<PayoutDetails loading={loading} response={response} />}
                </div>
                {loading && <Loader />}
            </div >
        </>
    );
};

export default MyPayoutDetailOrg;
const themeColor = "#7b3a00";
const PayoutDetails = ({ response, loading }) => {
    if (!response) {
        return (!loading &&
            <div className="text-center p-5">
                <h5 style={{ color: themeColor }}>No data found</h5>
            </div>
        );
    }

    const selfData = response.AssoSelfBPayoutDetailListData || [];
    const teamData = response.AssoTeamBPayoutDetailListData || [];

    return (
        <div className="  py-4">

            {/* SELF BUSINESS SECTION */}
            <div className="card shadow mb-4 border-0 rounded-3">
                <div className="card-body">
                    <h4
                        className="fw-bold mb-3 pb-2 border-bottom"
                        style={{ color: themeColor }}
                    >
                        Self Business Payout Details
                    </h4>
                    {selfData.length === 0 ? (
                        <p className="text-danger text-center fs-6">No self business payout data available.</p>
                    ) : (
                        selfData.map((payout, index) => (
                            <div key={index} className="mb-4">
                                {/* General Info */}
                                <div className="row mb-3">
                                    {index + 1}.
                                    <div className="col-md-6 ps-1">
                                        <strong>Business Amount: </strong>{" "}
                                        <span className="badge bg-org fw-bold">{convertToINRFormat(payout?.PaidAmount)}</span>
                                    </div>
                                    <div className="col-md-6 ">
                                        <strong>Business By: </strong>{payout?.AssoName ? payout?.AssoName : "---"}
                                    </div>
                                    <div className="col-md-6">
                                        <strong>Customer:</strong> {payout?.CustomerName ? payout?.CustomerName : "----"}
                                    </div>
                                    <div className="col-md-6">
                                        <strong>Business Date:</strong><span className=""> {payout.PaymentDate}</span>
                                    </div>
                                    <div className="col-md-6">
                                        <strong>Point Value (Direct / Level):</strong>  {payout?.DirectPVAmount + "/" + payout?.LevelPVAmount}
                                    </div>
                                    <div className="col-md-6">
                                        <strong>Point Value in Percent (Direct / Level):</strong>{payout?.DirectPVPercentage + "/" + payout?.LevelPVPercentage}
                                    </div>
                                    {/* <div className="col-md-6">
                                        <strong>Payment Type:</strong>{" "}
                                        <span className="badge bg-info">{payout.PaymentType}</span>
                                    </div> */}
                                    {/* <div className="col-md-6">
                                        <strong>Amount Type:</strong>{" "}
                                        <span className="badge bg-dark">{payout.AmountType}</span>
                                    </div> */}


                                    <div className="col-md-6">
                                        <strong>Plot No: </strong>
                                        <span className="badge bg-org">{payout.PlotNo}</span>
                                    </div>
                                </div>

                                {/* JSON Team Data Table */}
                                <div className="table-responsive">
                                    <table className="table table-bordered table-hover text-white">
                                        <thead style={{ backgroundColor: themeColor, color: "#fff" }}>
                                            <tr>
                                                <th className=" text-white">Business Amount</th>
                                                <th className=" text-white">Income Amount</th>
                                                <th className=" text-white">Income Type</th>
                                                <th className=" text-white">PV %</th>
                                                <th className=" text-white">PV Value</th>
                                                <th className=" text-white">Commission %</th>
                                                <th className=" text-white">Rank</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {payout.JSONDetailsSelfData?.map((row, idx) => (
                                                <tr key={idx}>
                                                    <td className="ps-2">{convertToINRFormat(row?.BusinessAmount)}</td>
                                                    <td>{convertToINRFormat(row.IncomeAmount)}</td>
                                                    <td>{row.IncomeType}</td>
                                                    <td>{row.PVPercent}%</td>
                                                    <td>{row.PVValue}</td>
                                                    <td>
                                                        {parseInt(row.SBCPercent) > 0 ? parseInt(row.SBCPercent) : parseInt(row.TBCPercent) ? parseInt(row.TBCPercent) : 0} % {row?.IncomeType}
                                                    </td>
                                                    <td className="ps-2">{row.Rank}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        ))
                    )}
                </div>
            </div>

            {/* TEAM BUSINESS SECTION */}
            <div className="card shadow mb-4 border-0 rounded-3">
                <div className="card-body">
                    <h4
                        className="fw-bold mb-3 pb-2 border-bottom"
                        style={{ color: themeColor }}
                    >
                        Team Business Payout Details
                    </h4>
                    {teamData.length === 0 ? (
                        <p className="text-danger text-center fs-6">No team business payout data available.</p>
                    ) : (
                        teamData.map((payout, index) => (
                            <div key={index} className="mb-4">
                                {/* General Info */}
                                <div className="row mb-3">
                                    {index + 1}.
                                    <div className="col-md-6 ps-1">
                                        <strong>Business By: </strong>{payout?.AssoName ? payout?.AssoName : "---"}
                                    </div>
                                    <div className="col-md-6">
                                        <strong>Customer:</strong> {payout?.CustomerName ? payout?.CustomerName : "----"}
                                    </div>
                                    <div className="col-md-6">
                                        <strong>Business Date:</strong><span className=""> {payout.PaymentDate}</span>
                                    </div>
                                    <div className="col-md-6">
                                        <strong>Point Value (Direct / Level):</strong>  {payout?.DirectPVAmount + "/" + payout?.LevelPVAmount}
                                    </div>
                                    <div className="col-md-6">
                                        <strong>Point Value in Percent (Direct / Level):</strong>{payout?.DirectPVPercentage + "/" + payout?.LevelPVPercentage}
                                    </div>
                                    {/* <div className="col-md-6">
                                        <strong>Payment Type:</strong>{" "}
                                        <span className="badge bg-info">{payout.PaymentType}</span>
                                    </div> */}
                                    {/* <div className="col-md-6">
                                        <strong>Amount Type:</strong>{" "}
                                        <span className="badge bg-dark">{payout.AmountType}</span>
                                    </div> */}
                                    <div className="col-md-6">
                                        <strong>Business Amount: </strong>{" "}
                                        <span className="badge bg-org fw-bold">{convertToINRFormat(payout?.PaidAmount)}</span>
                                    </div>

                                    <div className="col-md-6">
                                        <strong>Plot No: </strong>
                                        <span className="badge bg-org">{payout.PlotNo}</span>
                                    </div>
                                </div>

                                {/* JSON Team Data Table */}
                                <div className="table-responsive">
                                    <table className="table table-bordered table-hover text-white">
                                        <thead style={{ backgroundColor: themeColor, color: "#fff" }}>
                                            <tr>
                                                <th className=" text-white">Business Amount</th>
                                                <th className=" text-white">Income Amount</th>
                                                <th className=" text-white">Income Type</th>
                                                <th className=" text-white">PV %</th>
                                                <th className=" text-white">PV Value</th>
                                                <th className=" text-white">Commission %</th>
                                                <th className=" text-white">Rank</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {payout.JSONDetailsTeamData?.map((row, idx) => (
                                                <tr key={idx}>
                                                    <td className="ps-2">{convertToINRFormat(row?.BusinessAmount)}</td>
                                                    <td>{convertToINRFormat(row.IncomeAmount)}</td>
                                                    <td>{row.IncomeType}</td>
                                                    <td>{row.PVPercent}%</td>
                                                    <td>{row.PVValue}</td>
                                                    <td>
                                                        {/* {row.SBCPercent} */}

                                                        {parseInt(row.SBCPercent) > 0 ? parseInt(row.SBCPercent) : parseInt(row.TBCPercent) ? parseInt(row.TBCPercent) : 0} % {row?.IncomeType}

                                                    </td>
                                                    <td className="ps-2">{row.Rank}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        ))
                    )}
                </div>
            </div>
        </div>
    );
};

const PayoutSummaryCards = ({ response }) => {
    if (!response) return null;
    const {
        AssociateName,
        AssociateCode,
        Rank,
        PayoutNo,
        ClosingDate,
        TotalSelfBussiness,
        TotalSelfIncome,
        TotalTeamBussiness,
        TotalTeamIncome,
    } = response;

    const cardStyle = {
        backgroundColor: themeColor,
        color: "#fff",
        borderRadius: "12px",
        padding: "16px",
        // minHeight: "100px",
    };
    const labelStyle = { fontWeight: "500", fontSize: "0.95rem" };
    const valueStyle = { fontWeight: "500", fontSize: "0.9rem", textAlign: "right" };

    return (
        <div className=" py-3">
            <div className="row g-3">
                {/* Associate Info */}
                <div className="col-lg-3 col-sm-6">
                    <div className="card shadow border-0" style={cardStyle}>
                        <div className="d-flex justify-content-between align-items-center row-gap-4 my-2">
                            <span style={labelStyle}>Associate :</span>
                            <span style={valueStyle}>{AssociateName}</span>
                        </div>
                        <div className="d-flex justify-content-between align-items-center ">
                            <span style={labelStyle}>Code:</span>
                            <span style={valueStyle}>
                                {AssociateCode} [{Rank}]
                            </span>
                        </div>
                    </div>
                </div>

                {/* Payout Info */}
                <div className="col-lg-3 col-sm-6">
                    <div className="card shadow border-0" style={cardStyle}>
                        <div className="d-flex   justify-content-between align-items-center my-2">
                            <span style={labelStyle}>Payout No :</span>
                            <span style={valueStyle}>{PayoutNo}</span>
                        </div>
                        <div className="d-flex   justify-content-between align-items-center ">
                            <span style={labelStyle}>Closing Date:</span>
                            <span style={valueStyle}>{ClosingDate}</span>
                        </div>
                    </div>
                </div>

                {/* Self Business */}
                <div className="col-lg-3 col-sm-6">
                    <div className="card shadow border-0" style={cardStyle}>
                        <div className="d-flex   justify-content-between align-items-center my-2">

                            <span style={labelStyle}>Self Business:</span>
                            <span style={valueStyle}>₹{TotalSelfBussiness}</span>
                        </div>
                        <div className="d-flex   justify-content-between align-items-center ">

                            <span style={labelStyle}>Self Income:</span>
                            <span style={valueStyle}>₹{TotalSelfIncome}</span>
                        </div>

                    </div>
                </div>

                {/* Team Business */}
                <div className="col-lg-3 col-sm-6">
                    <div className="card shadow border-0" style={cardStyle}>
                        <div className="d-flex   justify-content-between align-items-center my-2">

                            <span style={labelStyle}>Team Business:</span>
                            <span style={valueStyle}>₹{TotalTeamBussiness}</span>
                        </div>
                        <div className="d-flex   justify-content-between align-items-center">

                            <span style={labelStyle}>Team Income:</span>
                            <span style={valueStyle}>₹{TotalTeamIncome}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

// export default PayoutSummaryCards;
